import Button from "@/lib/Button";
import Input from "@/lib/Input";
import { useState } from "react";
import Layout from "./Layout";
import StyledLink from "@/lib/StyledLink";
import toast from "react-hot-toast";
import $api from "@/lib/queries/openapi";

export default function ForgetPassword() {
  const [email, setEmail] = useState("");
  const emailValid = email.length;

  const { mutate: requestPasswordReset } = $api.useMutation(
    "post",
    "/api/auth/password/request",
    {
      onSuccess: () => {
        toast.success("Check your email for the reset link");
        setEmail("");
      },
    },
  );

  return (
    <Layout title="Reset Password">
      <>
        <Input
          label="Email"
          value={email}
          onChange={setEmail}
          type="email"
          placeholder="Email"
          autoComplete="on"
          name="email"
        />
        <Button
          primary
          size="lg"
          disabled={!emailValid}
          onClick={() => requestPasswordReset({ body: { email } })}
        >
          Send Reset Link
        </Button>
        <StyledLink to="/login">Sign in</StyledLink>
      </>
    </Layout>
  );
}
